import { AdmissionStatus } from './AdmissionStatus';
import { fileActionLabel } from '../../admission/selectors';
import { sourceFormLabel, vaultRoleLabel } from '../../admission/labels';

export function FileAdmissionCells({ assessment, onReview, disabled }) {
  const check = assessment?.admission_check || null;
  const canReview = Boolean(onReview);
  return (
    <>
      <td className="px-2 py-2 text-[12px] text-eorig-ink">
        {vaultRoleLabel(assessment?.vault_role)}
      </td>
      <td className="px-2 py-2 text-[12px] text-eorig-ink">
        {sourceFormLabel(assessment?.source_form)}
      </td>
      <td className="px-2 py-2">
        {check ? <AdmissionStatus kind="check" status={check} /> : <span className="text-[12px] text-eorig-muted">—</span>}
      </td>
      <td className="px-2 py-2 text-right">
        {canReview ? (
          <button
            type="button"
            onClick={onReview}
            disabled={disabled}
            className="text-[12px] font-semibold text-eorig-navy-600 hover:text-eorig-cyan disabled:opacity-40"
          >
            {fileActionLabel(check)}
          </button>
        ) : null}
      </td>
    </>
  );
}
